import Layout from './components/layout';
import Details from './components/details';
import FocusModeDetails from './components/focusModeDetails';
import AlertLayout from '../alert/components/layout';

export default {
	Layout,
	Details,
	FocusModeDetails,
	AlertLayout
}